// extracted by mini-css-extract-plugin
export default {"chatLauncher":"ChatBotLauncher_chatLauncher__YNZsK","chatLauncherBtn":"ChatBotLauncher_chatLauncherBtn__A--mT"};